export const ASPECT_RATIO = {
  LANDSCAPE: 3 / 4,
  PORTRAIT: 4 / 3,
  SQUARE: 1,
} as const;

export type AspectRatioType = (typeof ASPECT_RATIO)[keyof typeof ASPECT_RATIO];

export const MIN_RESOLUTION: Record<
  AspectRatioType,
  {
    minHeight: number;
    minWidth: number;
  }
> = {
  [ASPECT_RATIO.LANDSCAPE]: {
    minHeight: 1024,
    minWidth: 768,
  },
  [ASPECT_RATIO.PORTRAIT]: {
    minHeight: 768,
    minWidth: 1024,
  },
  [ASPECT_RATIO.SQUARE]: {
    minHeight: 1000,
    minWidth: 1000,
  },
};

export const PORTRAIT_CAMERA_HEADER_HEIGHT = '7dvh';
export const LANDSCAPE_CAMERA_HEADER_WIDTH = '7dvw';

export const PORTRAIT_CAMERA_FOOTER_HEIGHT = '22dvh';
export const LANDSCAPE_CAMERA_FOOTER_WIDTH = '22dvw';

export const relativeZIndex = {
  countdownOverlay: 3,
  footer: 1,
  infoText: 3,
  tiltIndicator: 2,
  toggleCameraButton: 2,
  videoContainer: 1,
};
